import { Component, Input, OnInit } from '@angular/core';
import { FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { ModalController, Platform } from '@ionic/angular';
import { TalentJobFormatService } from 'src/modules/talent-dashboard/services/talent-job-format.service';
import { BulletinViewerComponent } from '../components/bulletin-viewer/bulletin-viewer.component';
import { IBulletin } from '../interfaces/bulletin.interface';
import { UserService } from '../services/user.service';



@Component({
  selector: 'app-bulletins',
  templateUrl: './bulletins.component.html',
  styleUrls: ['./bulletins.component.scss'],
})
export class BulletinsComponent implements OnInit {

  @Input() bulletins: IBulletin;
  @Input() entityId: string;
  @Input() skill: string;
  downloadInprogressPdfId: string;
  bulletinsLoader = {};

  constructor(private platform: Platform,
    private fileOpener: FileOpener,
    private transfer: FileTransfer,
    private file: File, 
    private talentJobFormatService: TalentJobFormatService,
    private modalController: ModalController,
    private userService: UserService) { }

  ngOnInit() {}

  async openBulletin(data) {
      // Handle template bulletins
      if (data.is_template) {
        this.bulletinsLoader[data._id] = true;
        try {
          data.secure_url = (await this.userService.assembleBulletin(data._id, this.skill)).fileUrl
        } catch(e) {
          console.log("error",e)
        } finally {
          this.bulletinsLoader[data._id] = false;
        }
      }

      // Determine bulletin type
      const isVideo = data.type === 'video-url';
      const isCustom = data.type === 'custom';
      
      const myModal = await this.modalController.create({
        component: BulletinViewerComponent,
        backdropDismiss: false,
        cssClass: 'wideModal',
        componentProps: {
          url: isVideo ? data.url : data.secure_url,
          title: data.name,
          isVideo: isVideo,
          isCustom: isCustom,
          description: isCustom ? data.description : '',
          isAcknowledgmentRequired: false,
          forceFullWatch: !!data.force_full_watch,
          bulletinId: data._id,
          isTemplate: data.is_template,
          entityId: this.entityId,
          skill: this.skill
        }
      });
      return await myModal.present();
    
  }

  openPdf(data) {
    if (!this.downloadInprogressPdfId) {
      console.log("opening pdf");
      const fileName = `ShiftBulletin-${data._id}.pdf`;
      const isBrowser = this.talentJobFormatService.isBrowserCheck();
      if ((this.platform.is('android') || this.platform.is('ios') || this.platform.is('ipad')
      ) && !isBrowser) {

        this.downloadInprogressPdfId = data._id;
        const path = this.file.dataDirectory;

        const fileTransfer: FileTransferObject = this.transfer.create();
        fileTransfer.download(data.secure_url, path + fileName).then(async (entry) => {
          this.fileOpener.open(path + fileName, 'application/pdf');
          this.downloadInprogressPdfId = null;
        }).catch((err) => {
          console.log(err);
          alert('Error saving file: ' + err.message);
          this.downloadInprogressPdfId = null;
        });
      } else {
        window.open(data.secure_url, '_system');
      }
    }
  }

  dimissModal() {
    this.modalController.dismiss();
  }

}
